import { CustomStringParam, FilterType, SchemaFilterType } from '@ui/src';

export const overviewCardsColumns = [
  {
    name: 'id',
    label: '',
    hidden: true,
  },
  {
    name: 'date',
    label: 'Date & time',
  },
  {
    name: 'description',
    label: 'Description',
  },
  {
    name: 'currency',
    label: 'Currency',
  },
  {
    name: 'amount',
    label: 'Amount',
  },
  {
    name: 'merchantName',
    label: 'Merchant name',
    filterModalPlacement: 'right',
  },
  {
    name: 'orderDetails',
    label: 'Order details',
    filterModalPlacement: 'right',
  },
];

export const overviewCardsSchema = {
  date: {
    value: CustomStringParam,
    type: SchemaFilterType.DATE_RANGE,
    queryNames: ['dateFrom', 'dateTo'],
  },
  dateFrom: {
    value: CustomStringParam,
    type: SchemaFilterType.DATE_RANGE,
  },
  dateTo: {
    value: CustomStringParam,
    type: SchemaFilterType.DATE_RANGE,
  },
  description: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  currency: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  amount: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  orderDetails: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  merchantName: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  balance: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
};

export const overviewCardsColumnsLabels = {
  date: 'Date & time',
  dateFrom: 'Date From',
  dateTo: 'Date To',
  description: 'Description',
  currency: 'Currency',
  amount: 'Amount',
  merchantName: 'Merchant Name',
  orderDetails: 'Order Details',
};

export const overviewCardsFiltersSchema = [
  {
    name: 'date',
    type: FilterType.DATE_RANGE,
  },
  {
    name: 'description',
    type: FilterType.TEXT,
    placeholder: 'Enter description...',
  },
  {
    name: 'currency',
    type: FilterType.RADIO,
    fields: [
      {
        title: 'EUR',
        value: 'eur',
      },
      {
        title: 'USD',
        value: 'usd',
      },
    ],
  },
  {
    name: 'merchantName',
    type: FilterType.TEXT,
    placeholder: 'Enter merchant name...',
  },
  {
    name: 'amount',
    type: FilterType.TEXT,
    placeholder: 'Enter amount sum...',
  },
  {
    name: 'orderDetails',
    type: FilterType.TEXT,
    placeholder: 'Enter text...',
  },
];
